// ============================================================================
// Trigger Edge Function send-visit-push dal frontend admin
// ============================================================================
// Chiamato dopo aver programmato/modificato una visita medica per inviare la
// notifica push al dispositivo del dipendente (se iscritto).
// Gli errori vengono solo loggati: non vogliamo bloccare il salvataggio della
// visita se la notifica fallisce.
// ============================================================================

import { supabase, isSupabaseConfigured } from "./supabase";

export async function sendVisitPush({ dipId, dipName, data, ora, tipo = "visita" }) {
  if (!isSupabaseConfigured) return { ok: false, reason: "not configured" };
  if (!dipId || !data) return { ok: false, reason: "missing fields" };
  try {
    const { data: res, error } = await supabase.functions.invoke("send-visit-push", {
      body: {
        dip_id: Number(dipId),
        dip_name: dipName || null,
        data,
        ora: ora || null,
        tipo,
      },
    });
    if (error) {
      console.warn("[sendVisitPush] errore", error);
      return { ok: false, error };
    }
    return { ok: true, ...(res || {}) };
  } catch (err) {
    console.warn("[sendVisitPush] eccezione", err);
    return { ok: false, error: err };
  }
}
